import { createSlice } from '@reduxjs/toolkit';
import Storage from './Storage';

const initialState = {
  openedSidebar: Storage.getItem('openedSidebar'),
};

const menuSidebar = createSlice({
  name: 'menuSidebar',
  initialState,
  reducers: {
    OPENED_SIDEBAR: (state, { payload }) => ({
      ...state,
      openedSidebar: payload.openedSidebar,
    }),
  },
});

export const { OPENED_SIDEBAR } = menuSidebar.actions;

export const menuSidebarSelector = state => state.menuSidebar;

export default menuSidebar.reducer;
